import { HISTORY_EMPTY_DISPLAY_VALUE } from './historyDisplayValue';

export function hasValue<T>(value: T): value is NonNullable<T> {
	return (
		value !== null &&
		value !== undefined &&
		value !== HISTORY_EMPTY_DISPLAY_VALUE
	);
}
